import FlierLogic from "./FlierLogic";
import FlierData from "../model/FlierData";
import GameSprite from "./GameSprite";
import Physics from "./Physics";
import EnemyProjectileLogic from "./EnemyProjectileLogic";
import MathUtil from "../utils/MathUtil";
import C_Snd from "../../const/C_Snd";
import Point3D from "../math/Point3D";

class MotherOfTheMoonLogic extends FlierLogic
{
    constructor(flierType)
    {
        super(flierType);
        this.isShooting = false; // indicates if the Mother is making the shootAnimation
        this.shooted = false; // If the mother shooted the projectile or not. Sets to true on Projectile Creation
        this.isLeaving = false; // If the mother started leaving the game or not
        this.isMovingToCenter = false; // If the mother is moving towards the center cause she reached her bounds

        this.baseVelocity = 12;
        this.velocity = this.baseVelocity;
        this.dirChangeDelay = 0;
        this.moveFactor = 0.01;

        this.mv = this.entitySystem.mainView;

        this.setAnimationCooldown(0);
        this.setShootDelay(0);
        this.scheduleNextShoot();
    }


    init()
    {
        super.init();
        this.physics = this.getEntity().getComponent(Physics);
        this.lastZ = this.physics.position.z;

        // slow other spawners
        this.app.eFactory.changeSpawnersSpeed(0.5);
    }


    // *** SHOOTING ***
    // The animation duration. Scheduling next shoot can start only after this cooldown is over;
    setAnimationCooldown(cd)
    {
        this.shootAnimCD = cd;
    }


    // The delay between the start of the animation and the creation of the Projectile
    setShootDelay(delay)
    {
        this.shootDelay = delay;
    }


    scheduleNextShoot()
    {
        let delay = FlierData.byType[this.flierType].shootDelay;
        let extraDelay = FlierData.byType[this.flierType].shootExtraDelay;
        this.shootCooldown = delay + Math.random()*extraDelay;
    }


    startShootAnim()
    {
        let s = this.getEntity().getComponent(GameSprite);
        if (!s.isAnimPlaying())
        {
            let randomHand = Math.floor(Math.random() * 5);
            // randomHand = 5; // TODO comment
            this.setHand(randomHand);
            let animTime = s.playShootAnim(randomHand);

            this.setShootDelay(s.projDelaySpawn[randomHand]);
            this.setAnimationCooldown(animTime);

            this.waitingToShoot = false;
            s.waitingToShoot = false;
            this.isShooting = true;
            this.shooted = false; // still havent created the projectile
        }
        else
        {
            this.waitingToShoot = true;
            s.waitingToShoot = true;
        }
    }


    shoot()
    {
        this.shooted = true;

        let s = this.getEntity().getComponent(GameSprite);
        let origin = this.getHand();

        let textureId = s.moonTextures[origin];

        let shootOrigins = FlierData.byType[this.flierType].shootOrigins;

        let xOffset = shootOrigins[origin].x;
        let yOffset = shootOrigins[origin].y;

        let pos = this.physics.position.clone();
        pos.x += xOffset * this.physics.getSize() / 100;
        pos.y += yOffset * this.physics.getSize() / 100;

        let moonSize = 7;

        let projectile = this.app.eFactory.getMotmProjectile(pos, moonSize, textureId);
        this.app.eSys.addEntity(projectile);
    }


    setHand(handId)
    {
        this.handId = handId;
    }


    getHand()
    {
        return this.handId;
    }


    scheduleChangeDirectionTimer()
    {
        let delay = FlierData.byType[this.flierType].directionDelay;
        let extraDelay = FlierData.byType[this.flierType].directionExtraDelay;

        this.dirChangeDelay = delay + Math.random()*extraDelay;
    }

    // *** MOVEMENTS ***
    changeMovementDirection(moveToCenter = false)
    {
        this.isMovingToCenter = moveToCenter;
        if (moveToCenter)
        {
            this.stopAndMoveTowardCenter();

        }
        else if (Math.random() > 0.1)
        {
            this.setNewPositionVector(false);
        }
        else
        {
            this.stopMovement(2);
        }
    }


    stopAndMoveTowardCenter()
    {
        this.stopMovement(0.5);
        TweenMax.delayedCall(0.5, this.setNewPositionVector, [true], this);
        this.setNewPositionVector(true);
    }


    setNewPositionVector(center)
    {
        let currentPositionZ = this.physics.position.z;
        let zDistance = MathUtil.getRandomInt(125, 150);
        let randomZ;
        if (currentPositionZ - zDistance < 200)
        {
            randomZ = currentPositionZ + zDistance;
        }
        else if (currentPositionZ + zDistance > 500)
        {
            randomZ = currentPositionZ - zDistance;
        }
        else
        {
            let chance = 0.5;
            if (chance < Math.random()) {
                randomZ = currentPositionZ - zDistance;
            }
            else {
                randomZ = currentPositionZ + zDistance;
            }
        }
        // randomZ = MathUtil.getRandomInt(250, 800);

        let projPt = this.app.layout.projectGameToScreen(this.physics.position, this.physics.size);
        let localPt = this.mv.toLocal(this.mv.mainContainer.toGlobal(new PIXI.Point(projPt.x, projPt.y)));
        localPt.x *= 100 / this.app.layout.relWidth(100);
        localPt.y *= 100 / this.app.layout.relHeight(100);
        let endRelPosX;
        let endRelPosY;
        if (!center)
        {
            endRelPosX = localPt.x + 20 - Math.random() * 40;
            endRelPosY = localPt.y + 20 - Math.random() * 40;

            // endRelPosX = 120;
            // endRelPosY = 0;
        }
        else
        {
            endRelPosX = localPt.x + this.physics.toX;
            endRelPosY = localPt.y + this.physics.toY;

        }
        let end2DPos = new PIXI.Point(this.app.layout.relWidth(endRelPosX), this.app.layout.relHeight(endRelPosY));
        end2DPos = this.mv.mainContainer.toLocal(this.mv.toGlobal(end2DPos));


        let screenToGamePos = this.app.layout.projectScreenToGame3D(end2DPos, randomZ);
        // console.log(screenToGamePos);
        this.moveTowardsPosition = screenToGamePos;
    }


    stopMovement(dur)
    {
        this.moveTowardsPosition = null;
        let vel = this.physics.velocity;

        TweenMax.to(vel, dur, {x: 0, y: 0, z: 0});
    }


    goOutOfScreen()
    {
        if (!this.isLeaving)
        {
            this.isLeaving = true;

            let out;
            if (this.physics.position.x < 0) out = new Point3D(-30, MathUtil.getRandomInt(-30, 30), -10);
            else out = new Point3D(30, MathUtil.getRandomInt(-30, 30), -10);

            this.leavePosition = out;

            this.app.eFactory.changeSpawnersSpeed(1);
        }

    }


    updateVelocity()
    {
        if (this.isLeaving && this.leavePosition)
        {
            this.moveTowardsPos(this.leavePosition);
        }
        else if (this.moveTowardsPosition)
        {
            this.moveTowardsPos(this.moveTowardsPosition);
        }
    }

    moveTowardsPos(towardsPos)
    {
        let targetVector = towardsPos.subtract(this.physics.position);
        targetVector.normalize();
        targetVector.scale(this.velocity);

        this.physics.velocity.moveTowards(targetVector, this.moveFactor);
    }


    update(delta)
    {
        this.shootCooldown -= delta;


        if (this.shootCooldown <= 0 && !this.isShooting)
        {
            this.startShootAnim();
        }

        if (this.isShooting)
        {
            // shooting (creating projectile) after a delay
            this.shootDelay -= delta;
            if (this.shootDelay <= 0 &&  !this.shooted)
            {
                this.shoot();
            }

            // scheduling next shoot, current shoot is over
            this.shootAnimCD -= delta;
            if (this.shootAnimCD <= 0)
            {
                this.isShooting = false;
                this.scheduleNextShoot();
            }
        }

        if (this.physics.shouldLeave)
        {
            this.goOutOfScreen();
        }
        else
        {
            this.dirChangeDelay -= delta;
            if (this.dirChangeDelay <= 0)
            {
                this.changeMovementDirection();
                this.scheduleChangeDirectionTimer();
            }
        }

    }


    postPhysicsUpdate(delta)
    {
        super.postPhysicsUpdate(delta);

        if (this.physics.shouldChangeDirection() && !this.isMovingToCenter)
        {
            this.changeMovementDirection(true);
            this.scheduleChangeDirectionTimer();
        }

        this.updateVelocity();
    }


    kill(killAll = false)
    {
        if (this.alive)
        {
            this.alive = false;

            // this.app.sound.playSound(C_Snd.DESTROY[this.shipType], .3);

            let s = this.getEntity().getComponent(GameSprite);
            s.playDamageAnim();
            s.playDeathAnim();

            TweenMax.delayedCall(.5, this.finishKill, [], this);
        }
    }


    // constructor(flierType)
    // {
    //     super(flierType);
    //     this.shotsCounter = 0;
    //     this.beginShootDelay = 2;
    //     this.canShoot = false;
    //
    //     this.lastOrigin = -1; // so we can have always a random first origin to shoot from
    // }
    //
    //
    // scheduleShoot()
    // {
    //     this.spawnProjDelay = 4;
    //     this.shootDelay = FlierData.byType[this.flierType].shootDelay;
    // }
    //
    //
    // update(delta)
    // {
    //     let s = this.getEntity().getComponent(GameSprite);
    //
    //     this.shootDelay -= delta;
    //     if (this.shootDelay < 0 && s.getCanShoot())
    //     {
    //         let shootOrigins = FlierData.byType[this.flierType].shootOrigins;
    //         let numShots = shootOrigins.length;
    //
    //         let randShootOrigin = MathUtil.getRandomIntExclude(0, numShots-1, this.lastOrigin);
    //         this.lastOrigin = randShootOrigin;
    //
    //         let xOffset = shootOrigins[randShootOrigin].x;
    //         let yOffset = shootOrigins[randShootOrigin].y;
    //
    //
    //
    //         let p = this.getEntity().getComponent(Physics);
    //         let pos = p.position.clone();
    //         pos.x += xOffset * p.getSize() * s.aspect / 100;
    //         pos.y += yOffset * p.getSize() / 100;
    //
    //         let projectile = this.app.eFactory.getMotmProjectile(pos);
    //         projectile.getComponent(EnemyProjectileLogic).setSpawnDelay(this.spawnProjDelay);
    //         this.app.eSys.addEntity(projectile);
    //
    //         s.playShootAnimation(randShootOrigin, this.spawnProjDelay);
    //
    //         this.shotsCounter++;
    //         this.scheduleShoot();
    //     }
    // }
    //
    //
    // kill()
    // {
    //     if (this.alive)
    //     {
    //         this.alive = false;
    //
    //         // this.app.sound.playSound(C_Snd.DESTROY[this.shipType], .3);
    //
    //         let s = this.getEntity().getComponent(GameSprite);
    //         s.playDamageAnim();
    //         s.playDeathAnim();
    //
    //         TweenMax.delayedCall(1.5, this.finishKill, [], this);
    //     }
    // }
}

export default MotherOfTheMoonLogic;